export enum SearchTypes {
  SEARCH_BOOKS__ERROR = 'SEARCH_BOOKS__ERROR',
  SEARCH_BOOKS__REQUEST = 'SEARCH_BOOKS__REQUEST',
  SEARCH_BOOKS__SUCCESS = 'SEARCH_BOOKS__SUCCESS',
}
